import React from "react";

const TitleHeadingContext = React.createContext();

export default TitleHeadingContext;
